import { generate } from "../../helpers/element/generate-element";
import { slideDown } from "../../helpers/utils/slide";

class CalculatorTrestleTable {
    constructor() {
        this.requiredInputs = [
            'length',
            'boards',
            'finish',
            'quantity'
        ];

        this.inputGroups = [];
        this.values = [];
        this.costValue;
        this.hasDisplayed = false;

        this.defaultVariables = {

        };

        if (this.canInit()) {
            this.getInputs();
            this.addEvents();
        }
    }

    canInit() {
        return document.querySelector('.js-calc-form[data-form=trestle]') !== null;
    }

    getInputs() {
        const inputGroups = document.querySelectorAll('.js-calc-form .af-field');

        this.inputGroups = [...inputGroups].filter((group) => {
            return this.requiredInputs.includes(group.dataset.name);
        });
    }

    addEvents() {
        const trigger = document.querySelector('.js-calculate.button');

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleClick();
        })
    }

    handleClick() {
        this.getVariableValues();
        this.getInputValues();
        this.doCalculation();
        this.displayValues();
    }

    getVariableValues() {
        let definedVariables = {};

        if (typeof values_data !== 'undefined' && values_data !== null) {
            definedVariables = values_data;
        }

        this.variables = { ...this.defaultVariables, ...definedVariables };
    }

    getInputValues() {
        this.inputGroups.forEach((inputGroup) => {
            const name = inputGroup.dataset.name;
            const input = inputGroup.querySelector('input');
            const select = inputGroup.querySelector('select');
            let value;

            if (input !== null) {
                value = input.value;
            }

            if (select !== null) {
                value = select.options[select.selectedIndex].value;;
            }

            this.values['_' + name] = value;
        });
    }

    doCalculation() {

        // Input Values
        const finishCost = this.getFinishValue();

        const quantity = parseInt(this.values._quantity, 10);
        const length = parseInt(this.values._length, 10);
        const boards = parseInt(this.values._boards, 10);

        const linear = (length / 1000) * boards;
        const assemblyPrice = 50;

        const price = (linear * finishCost) + assemblyPrice;
        const totalPrice = (price * quantity);

        this.costValue = totalPrice.toFixed(2);
    }

    getFinishValue() {
        switch (this.values._finish) {
            case 'stained':
                return 27;
                break;
            case 'clear':
                return 26;
                break;
            case 'smooth':
                return 16;
                break;
            case 'rustic':
                return 6;
                break;
            default:
                return 6;
        }
    }

    displayValues() {
        const container = document.querySelector('.calc-form-sum__calculated');

        const submitButtons = document.querySelector('.af-submit');
        const costArea = document.querySelector('.calc-form-sum__cost');

        if (this.costValue === "NaN") {
            container.classList.add('has-error');
            const costElem = generate('span', `Please enter all values`, []);
            costArea.classList.add('is-hidden');

            setTimeout(() => {
                costArea.innerHTML = '';
                costArea.appendChild(costElem);
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                }, 300);
            }

            if (this.hasDisplayed) {
                slideUp(submitButtons, 300);
                this.hasDisplayed = false;
            }
        } else {
            const costElem = generate('span', `£${this.costValue}`, []);

            container.classList.remove('has-error');
            costArea.classList.add('is-hidden');

            setTimeout(() => {
                costArea.innerHTML = '';
                costArea.appendChild(costElem);
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(submitButtons, 300, 'flex');
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                    this.hasDisplayed = true;
                }, 300);
            }
        }
    }
}

export const calculatorTrestleTable = () => {
    new CalculatorTrestleTable(); // eslint-disable-line no-new
};
